import React, { useEffect, useRef, useState } from "react";
import PartsIcon from "../../img/navigation/parts.png";
import accessoriesIcon from "../../img/navigation/accessories.png";
import clothingIcon from "../../img/navigation/clothing.png";
import { useDispatch } from "react-redux";
import { fetchAllNavigationsAsync } from "../../features/HomePage/homeSlice";
import Navigations from "./Navigations";

const navItems = [
  {
    id: 1,
    label: "Parts",
    icon: PartsIcon,
    bg: "rgb(175, 187, 212)",
    activeClass: "parts-vertical-active",
    hrClass: "headers-middle-parts-vartical-hr",
  },
  {
    id: 2,
    label: "Accessories",
    icon: accessoriesIcon,
    bg: "rgb(168, 213, 180)",
    activeClass: "accessories-vertical-active",
    hrClass: "headers-middle-accessories-vartical-hr",
  },
  {
    id: 3,
    label: "Maintenance",
    icon: clothingIcon,
    bg: "rgb(216, 170, 169)",
    activeClass: "maintenance-vertical-active",
    hrClass: "headers-middle-maintenance-vartical-hr",
  },
];

const VerticalNavigationItems = () => {
  const dispatch = useDispatch();
  const [showNavigation, setShowNavigation] = useState(null);
  const containerRef = useRef(null);
  const timeoutRef = useRef(null);

  const handleNavigations = (id) => {
    if (showNavigation !== id) {
      dispatch(fetchAllNavigationsAsync(id));
      setShowNavigation(id);
    }
  };

  const handleMouseEnter = (id) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    handleNavigations(id);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowNavigation(null);
    }, 200); // Delay to prevent flicker
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <>
      {showNavigation && <div className="navigations-overlay"></div>}
      <div
        className="headers-middle-vertical-container"
        onMouseLeave={handleMouseLeave}
        onMouseEnter={() => {
          if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }}
        ref={containerRef}
      >
        {navItems.map(({ id, label, icon, bg, activeClass, hrClass }) => (
          <div
            key={id}
            className="w-[75px] md:w-[100px] flex items-center justify-center"
          >
            <div
              className="headers-middle-each-vertical-container"
              onMouseEnter={() => handleMouseEnter(id)}
              onClick={() => handleNavigations(id)}
            >
              <img
                loading="lazy"
                src={icon}
                alt={label}
                className="headers-middle-each-vertical-img"
                style={{ background: bg }}
              />
              <span className="headers-middle-each-vertical-name">{label}</span>
              <hr
                className={hrClass}
                id={showNavigation === id ? activeClass : undefined}
              />
            </div>
          </div>
        ))}
        {showNavigation && (
          <div className="headers-middle-vertical-open-container">
            <Navigations
              handleNavigations={handleNavigations}
              showNavigation={showNavigation}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default VerticalNavigationItems;
